import Entity from '../Entity';

export default class UserStoryBrowsingHistory implements Entity {
  constructor(
    public id: number,
    public storyId: number,
    public browsing: boolean,
    public createdAt: Date,
    public updatedAT: Date,
  ) {}
}
